<template>
    <AppLayout>
        <div class="bg-white">
            <!-- Hero banner -->
            <div v-if="product" class="relative bg-[#17364a] overflow-hidden">
                <img :src="product.image" :alt="product.imageAlt"
                    class="absolute inset-0 w-full h-full object-cover opacity-20" />
                <div class="relative mx-auto max-w-7xl px-6 lg:px-8 py-20">
                    <nav aria-label="Breadcrumb" class="mb-6">
                        <ol role="list" class="flex items-center space-x-2">
                            <li v-for="breadcrumb in breadcrumbs" :key="breadcrumb.id" class="flex items-center">
                                <a :href="breadcrumb.href" class="text-xs text-gray-400 hover:text-white transition-colors">{{ breadcrumb.name }}</a>
                                <span class="mx-2 text-gray-600">/</span>
                            </li>
                            <li v-if="product" class="text-xs text-gray-300">{{ product.name }}</li>
                        </ol>
                    </nav>
                    <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830] mb-3 block">Course</span>
                    <h1 class="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">{{ product.name }}</h1>
                </div>
            </div>

            <!-- Content -->
            <div v-if="product" class="mx-auto max-w-7xl px-6 lg:px-8 py-12 lg:py-16">
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-12">
                    <!-- Left: description -->
                    <div class="lg:col-span-2">
                        <h2 class="text-xs font-semibold uppercase tracking-widest text-[#A07830] mb-4">Description</h2>
                        <p class="text-sm text-gray-600 leading-relaxed">{{ product.description }}</p>
                    </div>

                    <!-- Right: sticky sidebar -->
                    <div class="lg:sticky lg:top-24 self-start">
                        <div class="border border-[#E5E5E5] p-6">
                            <div v-if="reviews" class="flex items-center gap-2 mb-5">
                                <div class="flex items-center">
                                    <StarIcon v-for="rating in [0, 1, 2, 3, 4]" :key="rating"
                                        :class="[reviews.average > rating ? 'text-[#A07830]' : 'text-gray-200', 'size-4 shrink-0']"
                                        aria-hidden="true" />
                                </div>
                                <a :href="reviews.href" class="text-xs text-gray-500 hover:text-[#A07830] transition-colors">
                                    {{ reviews.totalCount }} reviews
                                </a>
                            </div>
                            <Button v-if="product"
                                class="w-full"
                                label="Enroll now"
                                style="background: #17364a; border: none; border-radius: 0; font-weight: 600;"
                                @click="router.push({ name: 'checkout', params: { slug: product.slug } })">
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import { ref } from 'vue';
import { StarIcon } from '@heroicons/vue/20/solid';
import { onMounted } from 'vue';
import { getProductBySlug } from '@/services/productService';
import { useRouter } from 'vue-router';
import Button from 'primevue/button';
import AppLayout from '@/components/layouts/AppLayout.vue';

const router = useRouter();
const productSlug = router.currentRoute.value.params.slug;

const product = ref(null);
const breadcrumbs = [
    { id: 1, name: 'Courses', href: '/courses' },
]

onMounted(async () => {
    const response = await getProductBySlug(productSlug);
    product.value = response.data;
    console.log(response.data);
});

// const reviews = { href: '#', average: 4, totalCount: 117 }
</script>
